import React from 'react';
import Select from 'react-select';

const DropDown = (props) => {
  let styleOverrides = {
    placeholder: (provided, state) => ({ ...provided, color: 'black', fontSize: '18px' }),
    singleValue: (provided, state) => ({ ...provided, color: 'black', fontSize: '18px' }),
    control: (provided, state) => {
      let controlStyles = {
        borderColor: 'black',
        boxShadow: 'black',
        '&:hover': { borderColor: 'black' },
      };
      if (state.menuIsOpen) {
        controlStyles.borderBottomLeftRadius = '0';
        controlStyles.borderBottomRightRadius = '0';
        controlStyles.borderBottom = '0';
        controlStyles.fontSize = '18px';
      }
      return {
        ...provided,
        ...controlStyles,
      };
    },
    dropdownIndicator: (provided) => ({ ...provided, color: 'black' }),
    indicatorSeparator: () => ({ display: 'none' }),
    menuList: (provided, state) => ({
      ...provided,
      borderTopLeftRadius: '0',
      borderTopRightRadius: '0',
      border: '1px solid black',
      borderTop: '0',
      paddingBlock: '0',
      marginTop: '-1px',
    }),
    menu: (provided, state) => {
      let menuStyles = {
        fontSize: '18px',
        borderTopLeftRadius: '0',
        borderTopRightRadius: '0',
        marginTop: '-1px',
        borderColor: 'black',
      };
      if (state.menuIsOpen) {
        menuStyles.borderTop = '0';
      }
      return {
        ...provided,
        ...menuStyles,
      };
    },
    option: (provided, state) => ({
      ...provided,
      color: '#000',
      backgroundColor: state?.isSelected ? '#daf7f0' : state?.isFocused ? '#f3fcfa' : '#fff',
    }),
  };

  if (props.isDark)
    styleOverrides = {
      placeholder: (provided, state) => ({ ...provided, color: 'white', fontSize: '18px' }),
      singleValue: (provided, state) => ({ ...provided, color: 'white', fontSize: '18px' }),
      control: (provided, state) => {
        let controlStyles = {
          backgroundColor: '#001C3B',
          borderColor: 'white',
          boxShadow: 'white',
          '&:hover': { borderColor: 'white' },
        };
        if (state.menuIsOpen) {
          controlStyles.borderBottomLeftRadius = '0';
          controlStyles.borderBottomRightRadius = '0';
          controlStyles.borderBottom = '0';
          controlStyles.fontSize = '18px';
        }
        return {
          ...provided,
          ...controlStyles,
        };
      },
      dropdownIndicator: (provided, state) => ({
        ...provided,
        color: 'white !important',
        cursor: 'pointer',
      }),
      clearIndicator: (provided, state) => ({
        ...provided,
        color: 'white !important',
        cursor: 'pointer',
      }),
      indicatorSeparator: () => ({ display: 'none' }),
      menuList: (provided, state) => ({
        ...provided,
        backgroundColor: '#001C3B',
        borderTopLeftRadius: '0',
        borderTopRightRadius: '0',
        border: '1px solid white',
        borderTop: '0',
      }),
      menu: (provided, state) => {
        let menuStyles = {
          fontSize: '18px',
          borderTopLeftRadius: '0',
          borderTopRightRadius: '0',
          marginTop: '-1px',
          borderColor: 'white',
        };
        if (state.menuIsOpen) {
          menuStyles.borderTop = '0';
        }
        return {
          ...provided,
          ...menuStyles,
        };
      },
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state?.isSelected || state?.isFocused ? '#ffffff20' : '#001C3B',
      }),
    };

  if (props.outlined)
    styleOverrides = {
      placeholder: (provided, state) => ({ ...provided, color: 'white', fontSize: '18px' }),
      singleValue: (provided, state) => ({ ...provided, color: 'white', fontSize: '18px' }),
      control: (provided, state) => {
        let controlStyles = {
          backgroundColor: 'transparent',
          borderColor: 'white',
          boxShadow: 'white',
          '&:hover': { borderColor: 'white' },
        };
        if (state.menuIsOpen) {
          controlStyles.borderBottomLeftRadius = '0';
          controlStyles.borderBottomRightRadius = '0';
          controlStyles.borderBottom = '0';
          controlStyles.fontSize = '18px';
        }
        return {
          ...provided,
          ...controlStyles,
        };
      },
      dropdownIndicator: (provided, state) => ({
        ...provided,
        color: 'white !important',
        cursor: 'pointer',
      }),
      clearIndicator: (provided, state) => ({
        ...provided,
        color: 'white !important',
        cursor: 'pointer',
      }),
      indicatorSeparator: () => ({ display: 'none' }),
      menuList: (provided, state) => ({
        ...provided,
        backgroundColor: '#135050',
        borderBottomLeftRadius: '4px',
        borderBottomRightRadius: '4px',
        border: '1px solid white',
        borderTop: '0',
        paddingBlock: '0',
        marginTop: '-1px',
      }),
      menu: (provided, state) => {
        let menuStyles = {
          fontSize: '18px',
          borderTopLeftRadius: '0',
          borderTopRightRadius: '0',
          marginTop: '-1px',
          borderColor: 'white',
        };
        if (state.menuIsOpen) {
          menuStyles.borderTop = '0';
        }
        return {
          ...provided,
          ...menuStyles,
        };
      },
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state?.isSelected || state?.isFocused ? '#ffffff20' : '#135050',
      }),
    };

  return <Select styles={styleOverrides} {...props} />;
};

export default DropDown;
